<template>
  <div class="nheader flex-between">
    <div class="flex-center point mr30" @click="goPage({ path: '/index/index', id: 1 })">
      <img class="logoi" :src="appInfo.logo" alt="" />
      <span>{{ appInfo.platform_name }}</span>
    </div>
    <div class="flex-center">
      <div @click="goPage(item)" v-for="item in pageList" :key="item.id" class="navone donghua"
        :class="currentIndex == item.id ? 'activenav' : ''">
        {{ item.name }}
      </div>

      <!-- <div class="navone">
        <el-input placeholder="关键字内容" v-model="search" size="small" @keyup.enter.native="handleSearch">
          <i slot="prefix" class="el-input__icon el-icon-search"></i>
        </el-input>
      </div> -->
      <div class="flex navone ml26">
        <template v-if="userInfo && userInfo.nickname">
          <img :src="userInfo.avatar" class="avaimg" alt="">
          <div class="fw400">{{ userInfo.nickname }},{{ getTimeText() }}好</div>
          <div class="logbtn"> <el-button @click="logOut" type="primary" size="mini" class="logoutbtn">退出</el-button>
          </div>
        </template>
        <template v-else>
          <div class="fw400 fs16">您好,请先登录</div>
          <el-button @click="goLogin" type="primary" size="mini" class="logbtn">登录</el-button>
        </template>
        <!-- <div class="msgbox">
          <img @click="goMessage" src="@/assets/index/message.png" class="mesgicon" alt="">
          <div v-if="userInfo.notice_status" class="digt"></div>
        </div> -->
      </div>
    </div>
  </div>
</template>

<script>




export default {
  name: "NavHeader",
  data() {
    return {
      search: '',
      currentIndex: 1,
      pageList: [
        { path: '/index/index', id: 1, name: '材料目录' },
        { path: '/index/valuationRecovery', id: 2, name: '估值回收' },
        { path: '/index/myOrder', id: 3, name: '我的订单' },
        { path: '/index/commonProblem', id: 4, name: '常见问题' },
        { path: '/index/myService', id: 5, name: '我的服务' },
        { path: '/index/message', id: 6, name: '系统消息' },
      ]
    };
  },
  mounted() {
    this.getAppInfo()
    console.log(this.$route.path)
    let findObj = this.pageList.find(item => this.$route.path.includes(item.path))
    if (findObj && findObj.id) {
      this.currentIndex = findObj.id
    }
    if (localStorage.getItem('token')) {
      console.log('登录')
      this.getUserInfo()
    }
  },
  watch: {
    $route: {
      handler(to, from) {

        let findObj = this.pageList.find(item => to.path.includes(item.path))
        console.log(findObj, "caocao ")

        if (findObj && findObj.id) {
          this.currentIndex = findObj.id
        }
      },
      deep: true,
      immediate: true,

    }
  },

  methods: {
    handleSearch() {
      // if(!this.search) return 
      // console.log('123465')
      this.$router.push(`/index/index?search=${this.search}`)
      this.currentIndex = 1
    },
    goMessage() {
      this.$router.push('/index/message')
    },
    goPage(item) {
      this.currentIndex = item.id
      this.$router.push(item.path)
    },
    goIndex() {
      this.$router.push('/index/index')
    },
    goLogin() {
      this.$router.push('/login')
    },
    logOut() {
      localStorage.removeItem('user')
      localStorage.removeItem('token')
      this.setUserInfoAsync(null)
      this.$router.push('/login')
    },
    getTimeText() {
      const now = new Date();
      const currentHour = now.getHours();
      let period;

      if (currentHour >= 0 && currentHour < 8) {
        period = "早上";
      } else if (currentHour >= 8 && currentHour < 12) {
        period = "上午";
      } else if (currentHour >= 12 && currentHour < 18) {
        period = "下午";
      } else {
        period = "晚上";
      }
      return period;

    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.nheader {
  color: #333;
  height: 80px;
  line-height: 80px;
  font-size: 18px;
  background: #fff;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  padding: 0 12%;
  // padding: 0 160px;
  z-index: 9999;
  font-weight: 600;
  box-shadow: 0px 3px 10px 0px rgba(204, 214, 224, 0.35);
  box-sizing: border-box;

  .msgbox {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;

    .digt {
      width: 8px;
      height: 8px;
      border-radius: 50%;
      background: #FF4040;
      position: absolute;
      top: -4px;
      right: -4px;
      z-index: 999999;
    }

    .mesgicon {
      width: 28px;
      height: 28px;
    }
  }

  .donghua {
    min-width: 100px;
    transition: all 0.5s;
    text-align: center;

    &:hover {

      background-color: #E7F0F7;
      color: #218FFE;
    }
  }

  .navone {
    // margin-left: 40px;
    padding: 0 30px;
    cursor: pointer;

    .logbtn {
      margin: 0 30px;

      .logoutbtn {
        width: 70px;
        height: 36px;
        background: #218FFE;
        border-radius: 18px;
        font-size: 14px;
      }
    }



    .avaimg {
      width: 30px;
      height: 30px;
      margin-right: 10px;
      border-radius: 50%;

    }
  }

  .activenav {
    color: #218FFE;
    position: relative;

    &:after {
      content: '';
      position: absolute;
      bottom: 4px;
      left: 50%;
      transform: translateX(-50%);
      background: #218FFE;
      width: 30px;
      height: 4px;
    }

  }


  .logoi {
    width: 50px;
    // height: 50px;
    margin-right: 10px;
    border-radius: 3px;
  }
}
</style>
